import { useSearchParams } from 'next/navigation'

export function useAdNameParameter() {
    const searchParams = useSearchParams()
    return searchParams.get('adName')
}
